const SET_IS_CLASS_STUDENT = 'classes/SET_IS_CLASS_STUDENT';
const SET_SELECTED = 'classes/SET_SELECTED';
const SET_CLASSES = 'classes/SET_CLASSES';
const SET_JOINED_CLASSES = 'classes/SET_JOINED_CLASSES';

export default {
  SET_IS_CLASS_STUDENT,
  SET_SELECTED,
  SET_CLASSES,
  SET_JOINED_CLASSES,
};
